<div class="c-controlled-input {{classList}}">
	<span class="c-controlled-input_label">
		{{labelText}}
		{{#if @this.partials.labelIcon && !hideLabelIcon}}
			{{>labelIcon}}
		{{/if}}
	</span>

	{{#if @this.partials.copyBtn}}
		{{>copyBtn}}
	{{/if}}

	<div class="c-controlled-input_wrapper">
		<input
			{{#if id}}id="{{id}}"{{/if}}
			value="{{value}}"
			type="text"
			placeholder="{{placeholder}}"
			class="{{#if error}}has-error{{/if}}{{#if disabled}}is-disabled{{/if}} c-controlled-input_input"
			{{#if locked}}
			readonly="{{locked ? true : false}}"
			{{/if}}
			disabled="{{disabled}}">

		{{#if error}}
			<img class="c-controlled-input_err-icon"
				width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/alert-icon.svg">
		{{/if}}
	</div>

	{{#if error}}
		<span class="c-controlled-input_error">
			{{error}}
		</span>
	{{/if}}
</div>

<script>
	const listeners = require('../../assets/js/utils/listeners');
	const tooltip = require('../../assets/js/decorators/tooltip');
	const clipboard = require('../../assets/js/decorators/clipboard');

	component.exports = {
		decorators: {
			tooltip,
			clipboard,
		},
		data () {
			return {
				invalidValue: null,
				errMsgTopPos: false,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observeOnce('error', () => {
					this.set('invalidValue', this.get('value'));
				}, { init: false });

				this.observe('value', (value) => {
					let invalidValue = this.get('invalidValue');
					let error = this.get('error');

					if (error && invalidValue !== value) {
						this.set('error', undefined);
					}
				});

				this.observe('screenWidth', (screenWidth) => {
					if ((screenWidth || window.innerWidth) < 768) {
						this.set('errMsgTopPos', true);
					} else {
						this.set('errMsgTopPos', false);
					}
				});
			}
		},
		onrender () {
			listeners.screenWidthListener(this);
		},
	};
</script>
